export interface NavItem {
  label: string;
  path: string;
  icon: string;
}

export const MAIN_DRAMA_ID = "fengliu-nvguandian";

export const navItems: NavItem[] = [
  { label: "首页", path: "/", icon: "ri-home-5-line" },
  { label: "剧集分类", path: "/category", icon: "ri-film-line" },
  { label: "演员介绍", path: "/category?tab=actor", icon: "ri-user-star-line" },
  {
    label: "剧集点评",
    path: `/reviews/${MAIN_DRAMA_ID}`,
    icon: "ri-chat-quote-line",
  },
  { label: "关于我们", path: "/about", icon: "ri-information-line" },
  { label: "联系我们", path: "/contact", icon: "ri-customer-service-2-line" },
];